<template>
  <div class="listing-feed u-bottom-margin">
    <transition name="fade" mode="out-in">
      <div class="o-container" v-if="!hideTagList && tagsLoaded && initialFeedLoaded && tagList.length">
        <div class="mobile-toggle">
          <button class="mobile-toggle__button" :class="{ 'mobile-toggle__button--active' : showFilterAtMobile}" @click="toggleMobileFilter">
            <span class="sr-only">Open</span> Filters
          </button>
        </div>
        <app-filter :tags="tagList" :default-selected-tags="selectedTags" @selectedCategory="updateTagQs" :class="{ 'tag-filter--show-at-mobile' : showFilterAtMobile}" />
      </div>
    </transition>
    <div class="o-container o-container o-container--half-padding">
      <transition name="fade" mode="out-in">
        <div key="results" v-if="feedLoaded">
          <transition name="fade" mode="out-in">
            <div class="c-article-list" v-if="set[0].children.length">
              <listing-feed-set :hide-tags="hideTags" :layout="renderedLayoutType" :hierarchical-headings="hierarchicalHeadings" :default-selected-tags="selectedTags" v-for="(item, index) in set" :data="item.children" :key="`set-${index}`" />
              <div class="listing-feed__message" v-if="isLoadingMoreResults">
                <span class="sr-only">Loading</span>
                <loader />
              </div>
              <app-paging @loadMoreClicked="fetchData" :current-page="currentPage" :total-pages="totalPages" :current-visible-items-count="currentVisibleArticleItemCount" :total-items-count="totalArticleItemCount" />
            </div>
            <p v-else class="listing-feed__message">
              Sorry, no results. Please try adjusting the filters.
            </p>
          </transition>
        </div>
        <div v-else key="loading" class="listing-feed__message">
          <span class="sr-only">Loading</span>
          <loader />
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import ListingFeedSet from '../common/listing/listing-feed-set.vue'
import AppFilter from '../common/listing/tag-filter.vue'
import AppPaging from '../common/listing/paging.vue'
import VueRouter from 'vue-router'
import Loader from '../common/loader.vue'
import { getArticlesByParentId, getTagsByParentId } from '../../api/content/api.js'

const hierarchicalLayout = '2|3|4'

Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    routes: []
})

export default {
    router,
    placeholderId: 'article-listing-placeholder',
    props: {
        stubData: {
            type: String,
            required: false,
            default: ''
        },
        stubTags: {
            type: String,
            required: false,
            default: ''
        },
        hideTags: {
            type: String,
            required: false,
            default: ''
        },
        parentId: {
            type: String,
            required: false,
            default: ''
        },
        layoutType: {
            type: String,
            required: false,
            default: ''
        }
    },
    components: {
        ListingFeedSet,
        Loader,
        AppFilter,
        AppPaging
    },
    data() {
        return {
            set: [],
            currentPage: 0,
            showFilterAtMobile: false,
            tagsLoaded: false,
            totalPages: 0,
            initialFeedLoaded: false,
            feedLoaded: false,
            tagList: [],
            selectedTags: [],
            totalArticleItemCount: 0,
            isLoadingMoreResults: false
        }
    },
    computed: {
        queries() {
            const params = {}
            if (this.parentId) { params.parentId = this.parentId }
            if (this.selectedTags && this.selectedTags.length) {
                // requested to remove spaces from each item
                // requested to pipe seperate list
                const formattedArticleTagList = this.selectedTags.map(x => x.replace(/\s/g, '')).join('|')
                params.articleTags = formattedArticleTagList
            }
            if (this.currentPage) { params.pageNumber = this.currentPage }
            if (this.itemsPerPage) { params.itemsPerPage = this.itemsPerPage }
            return params
        },
        currentVisibleArticleItemCount() {
            return this.set.reduce((count, current) => count + current.children.length, 0)
        },
        hideTagList() {
            const hide = this.hideTags === 'True'
            if(hide) {
                return true
            }
            return false
        },
        renderedLayoutType() {
            if(this.layoutType === '') {
                return hierarchicalLayout
            }
            return this.layoutType
        },
        hierarchicalHeadings() {
            if(this.renderedLayoutType === hierarchicalLayout) {
                return true
            }
            return false
        },
        itemsPerPage() {
            if(this.renderedLayoutType == hierarchicalLayout) {
                return 9
            }
            return 12
        }
    },
    methods: {
        fetchData(loadMore) {
            if(this.stubData === '') {
                if(loadMore) {
                    this.currentPage++
                    this.isLoadingMoreResults = true
                    getArticlesByParentId(this.queries).then((response) => {
                        this.set.push({ children: response.data.data, currentPage: this.currentPage})
                        this.isLoadingMoreResults = false
                    })
                }
                else {
                    this.currentPage = 0
                    this.feedLoaded = false
                    getArticlesByParentId(this.queries).then((response) => {
                        this.set = [{children: response.data.data, currentPage: this.currentPage}]
                        this.totalPages = response.data.totalPages
                        this.totalArticleItemCount = response.data.TotalItemCount
                        this.feedLoaded = true
                        this.initialFeedLoaded = true
                    })
                }
            }
            else {
                // this is just for mock data in pattern library
                this.totalPages = 5
                const items = JSON.parse(this.stubData)
                this.totalArticleItemCount = 5 * 9
                const children = items
                if(loadMore) {
                    this.currentPage++
                    this.set.push({ children })
                }
                else {
                    this.feedLoaded = false
                    setTimeout(() => {
                        this.initialFeedLoaded = true
                        this.feedLoaded = true
                        this.set = [{ children } ]
                    }, 100)
                }
            }
        },
        updateQueries(tags) {
            const list = tags.toString()
            router.push({
                query: {
                    selectedTags: list
                }
            })
        },
        updateTagQs(payLoad) {
            this.selectedTags = payLoad
            if(this.selectedTags) {
                this.updateQueries(this.selectedTags)
            }
        },
        toggleMobileFilter() {
            this.showFilterAtMobile = !this.showFilterAtMobile
        },
        getTags() {
            if(this.stubTags === '' && this.parentId != '') {
                getTagsByParentId({
                    parentId: this.parentId
                }).then(response => {
                    this.tagList = response.data.data
                    this.tagsLoaded = true
                })
                    .catch(errors => {
                        console.error(errors)
                    })
            }
            else {
                const stubTags = JSON.parse(this.stubTags)
                this.tagList = stubTags
                this.tagsLoaded = true
            }
        },
        getValuesFromQueryString() {
            if(this.$route.query.selectedTags != null && this.$route.query.selectedTags != '') {
                this.selectedTags = this.$route.query.selectedTags.split(',')
            }
            if(this.$route.query.selectedTags == '') {
                const query = Object.assign({}, this.$route.query)
                delete query.selectedTags
                this.$router.replace({ query })
            }
        },
    },
    mounted() {
        this.getValuesFromQueryString()
        this.fetchData()
        if(!this.hideTagList) {
            this.getTags()
        }
    },
    watch: {
        '$route'() {
            this.getValuesFromQueryString()
            this.fetchData()
        }
    }
}
</script>